import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of, from } from 'rxjs';
import { SessionService } from '../session/session.service';
import { SessionApiService } from '../services/session.api.service';

/**
 * Resolver que garantiza que los permisos del usuario estén actualizados
 * antes de que se active una ruta
 */
@Injectable({ providedIn: 'root' })
export class PermissionsResolver implements Resolve<boolean> {
  
  constructor(
    private sessionService: SessionService,
    private sessionApiService: SessionApiService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    
    // Si no hay usuario logueado, no hacemos nada
    if (!this.sessionService.isLoggedIn() || !this.sessionService.user) {
      return of(true);
    }

    // SIEMPRE verificar con el servidor si hay cambios en los permisos
    return from(this.checkAndUpdatePermissions());
  }

  private async checkAndUpdatePermissions(): Promise<boolean> {
    try {
      const currentUser = this.sessionService.user;
      const currentPermissions = currentUser?.ListPermissions || [];

      // Verificar con el servidor si hay cambios
      const response = await this.sessionApiService.CheckPermissionsChanges(
        currentUser.idUser,
        currentPermissions
      );

      // Si hay cambios, actualizar los permisos
      if (response.changed && response.permissions) {
        console.log('Permisos actualizados por resolver antes de cargar componente');
        await this.sessionService.updatePermissions(response.permissions);
      }

      return true;
    } catch (error) {
      console.error('Error al verificar permisos en resolver:', error);
      return true; // Continuar incluso si hay error
    }
  }
}
